import { useEffect, useState } from "react";
import { MdLightbulbOutline } from "react-icons/md";
import { useLocation, useNavigate } from "react-router-dom";
import ConsultaFormContainer from "../../../components/ConsultaFormContainer/ConsultaFormContainer";
import Container from "../../../components/Container/Container";
import SearchContainer from "../../../components/SearchContainer/SearchContainer";
import SearchInput from "../../../components/SearchInput/SearchInput";
import { useListManager } from "../../../contexts/list.manager";
import FormAutomationButtons from "../FormAutomationButtons/FormAutomationButtons";
import ListAutomationButtons from "../ListAutomationButtons/ListAutomationButtons";
import "./ConsultaAutomationButtons.css";

const ConsultaAutomationButtons = () => {
	const [searchText, setSearchText] = useState("");
	const { lineSelected } = useListManager();
	const [filters, setFilters] = useState("");
	const navigate = useNavigate();
	const location = useLocation();
	const [refreshKey, setRefreshKey] = useState(0);

	useEffect(() => {
		if (location.state?.deletedId || location.state?.refresh) {
			setRefreshKey((k) => !k);
			navigate(location.pathname, { replace: true, state: {} });
		}
	}, [location.state, navigate, location.pathname]);

	return (
		<div className="consulta-container">
			<div className="search-list-wrapper">
				<SearchContainer
					icon={<MdLightbulbOutline size={20} />}
					title="Comandos de Automação"
					navigate="../cadastro-automation-buttons"
					buttonLabel="Adicionar"
				>
					<SearchInput
						value={searchText}
						placeholder="Buscar Comando de Automação"
						onChange={({ target }) => setSearchText(target.value)}
						onKeyPress={(e) => e.key === "Enter" && setFilters(searchText)}
					/>
				</SearchContainer>
				<Container>
					<ListAutomationButtons filters={filters} refreshKey={refreshKey} />
				</Container>
			</div>
			<ConsultaFormContainer>
				<FormAutomationButtons
					automationButton={lineSelected}
					formMode="consulta"
				/>
			</ConsultaFormContainer>
		</div>
	);
};

export default ConsultaAutomationButtons;
